<template>
  <div>
    <com-dialog :visible.sync="visible" :title="type === 'created' ? '新增' : '编辑'">
      <div>
        <el-form :model="form" label-width="120px">
          <el-form-item label="分成类别">
            <el-select v-model="form.type" placeholder="请选择" @change="changeType">
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="(item, index) in divvyCategory"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分成人" style="width: 340px">
            <el-select
              v-model="form.refPartner"
              placeholder="输入名称搜索"
              filterable
              remote
              :remote-method="getDivvyPerson"
              :loading="loading"
            >
              <el-option
                :label="item.name"
                :value="item.code"
                v-for="(item, index) in divvyPersons"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分成方式">
            <el-select v-model="form.divideType" placeholder="请选择">
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="(item, index) in divvyModes"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分成比例" style="width: 340px">
            <el-input
              v-model="form.divide"
              placeholder="请输入"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="生效时间" prop="effectiveTime">
            <el-date-picker
              v-model="form.effectiveTime"
              type="date"
              format="yyyy-MM-dd"
              placeholder="生效时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="到期时间" prop="expireTime">
            <el-date-picker
              v-model="form.expireTime"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="到期时间"
            >
            </el-date-picker>
          </el-form-item>
          <div class="flex items-center justify-end">
            <el-button type="" @click="close">取消</el-button>
            <el-button type="primary" @click="confirm">确认</el-button>
          </div>
        </el-form>
      </div>
    </com-dialog>
  </div>
</template>

<script>
import { addDivvySettingApi, updateDivvySettingApi } from '@/api/community'
import { partnersListApi } from '@/api/partners'
import utils from 'my-tools-library'

export default {
  data() {
    return {
      visible: false,
      title: '新增',
      type: '',
      form: {},
      divvyCategory: [
        { label: '合伙人', value: 1 },
        { label: '商家', value: 2 },
        { label: '代理商', value: 3 },
      ],
      divvyModes: [
        { label: '营业额分成', value: 1 },
        { label: '服务费分成', value: 2 },
        { label: '充值分成', value: 3 },
        { label: '套餐卡分成', value: 4 }
      ],
      divvyPersons: [],
      loading: false
    }
  },
  methods: {
    baseForm() {
      return {
        refResidentialArea: '',
        type: '',
        refPartner: '',
        divideType: '',
        divide: '',
        effectiveTime: '',
        expireTime: ''
      }
    },
    // 获取分成人 合伙人/商家/代理商
    getDivvyPerson(value) {
      console.log('value :>> ', value)
      if (!this.form.type) return this.$message.warning('请先选择分成类别')

      const param = {
        pageIndex: 1,
        pageSize: 10,
        type: this.form.type,
        name: value
      }
      this.loading = true
      partnersListApi(param).then((res) => {
        const { records } = res.data
        this.divvyPersons = records
        this.loading = false
      })
    },
    changeType() {
      // 清空分成人数据
      this.divvyPersons = []
      this.form.refPartner = ''
    },

    handleUpdate() {
      updateDivvySettingApi(this.form).then(() => {
        this.$emit('update')
        this.$message.success('操作成功')
        this.close()
      })
    },
    handleAdd() {
      addDivvySettingApi(this.form).then(() => {
        this.$emit('update')
        this.$message.success('操作成功')
        this.close()
      })
    },
    open(opt) {
      const { type, communityCode, row } = opt
      this.type = type
      if (type === 'edit') this.form = utils.deepCopy(row)
      if (type === 'created') this.form = this.baseForm()
      this.form.refResidentialArea = communityCode
      this.visible = true
    },
    close() {
      this.visible = false
      setTimeout(() => {
        this.form = {}
      }, 200)
    },
    confirm() {
      console.log('this.form :>> ', this.form)
      if (this.type === 'edit') {
        this.handleUpdate()
        return
      }
      this.handleAdd()
    }
  }
}
</script>

<style lang="scss" scoped></style>
